import gsap from 'gsap'
import Swiper from 'swiper';
import { Navigation, Pagination, Mousewheel } from 'swiper/modules';
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

document.addEventListener('DOMContentLoaded', () => {
    const block = document.querySelector('.c-treatments')
    if (!block) return

    const layout = block.dataset.layout || 'list'

    // === Función para slider ===
    function initSlider() {
        const slider = block.querySelector('.swiper')
        if (!slider) return

        const current = block.querySelector('.js-treatments-current')
        const total = block.querySelector('.js-treatments-total')

        new Swiper(slider, {
            modules: [Navigation, Pagination, Mousewheel],
            slidesPerView: 1.2,
            spaceBetween: 20,
            loop: false,
            grabCursor: true,
            mousewheel: true,
            pagination: { el: '.js-treatments-pagination', type: 'progressbar' },
            navigation: { nextEl: '.js-treatments-next', prevEl: '.js-treatments-prev' },
            breakpoints: { 768: { slidesPerView: 2.2 }, 1290: { slidesPerView: 4.2 } },
            on: {
                init() {
                    if (current) current.textContent = String(this.realIndex + 1).padStart(2, '0')
                    if (total) total.textContent = String(this.slides.length).padStart(2, '0')
                },
                slideChange() {
                    if (current) current.textContent = String(this.realIndex + 1).padStart(2, '0')
                }
            }
        })
    }

    // === Función para list ===
    function initList() {
        const block = document.querySelector('.c-treatments');
        if (!block) return;

        const images = gsap.utils.toArray('.c-treatments__image');
        const texts = gsap.utils.toArray('.c-treatments__text');
        const items = gsap.utils.toArray(
            '.c-treatments__item:not(.c-treatments__item--link)'
        );

        let currentIndex = 0;
        let z = 10;
        let isAnimating = false;

        const showItem = (index) => {
            if (index === currentIndex || isAnimating) return;

            isAnimating = true;
            const prev = currentIndex;
            currentIndex = index;
            z++;

            const currentImage = images[index];

            const tl = gsap.timeline({
                defaults: { ease: 'power3.out' },
                onComplete: () => {
                    isAnimating = false;
                },
            });

            // Imagen
            tl.set(currentImage, {
                zIndex: z,
                opacity: 1,
                clipPath: 'inset(50% round 12px)',
            }).to(currentImage, {
                clipPath: 'inset(0% round 0px)',
                duration: 1.2,
                ease: 'power3.inOut',
            });

            // Texto anterior
            if (texts[prev]) {
                gsap.to(texts[prev], {
                    autoAlpha: 0,
                    y: -20,
                    duration: 0.4,
                    ease: 'power2.out',
                });
            }

            // Texto actual
            if (texts[index]) {
                gsap.fromTo(
                    texts[index],
                    { autoAlpha: 0, y: 20 },
                    {
                        autoAlpha: 1,
                        y: 0,
                        duration: 0.8,
                        ease: 'power3.out',
                        delay: 0.3,
                    }
                );
            }

            // Estado activo en la lista
            items.forEach((item, i) =>
                item.classList.toggle('c-treatments__item--active', i === index)
            );
        };

        // Estado inicial
        showItem(0);

        // Hover
        items.forEach((item, index) => {
            item.addEventListener('mouseenter', () => {
                showItem(index);
            });
        });

        // Opcional: volver al primero al salir del bloque
        block.addEventListener('mouseleave', () => {
            showItem(0);
        });
    }

    // === Inicializar según layout ===
    if (layout === 'slider') initSlider()
    else initList()
})
